import Slider from './components/Slider';

const defaults = {
  groupCells: 2,
  arrowShape: 'M24.5,51.6v-3.2l19.6-19.6l3.2,3.2L31.5,47.8h44.1v4.5H31.5L47.2,68l-3.2,3.2L24.5,51.6z',
  selectedAttraction: 0.2, // default 0.025
  friction: 0.8, // default 0.28
  autoPlay: false,
  wrapAround: true,
  pageDots: false,
  responsive: {
    mobile: {
      prevNextButtons: false,
      pageDots: true,
      groupCells: 1,
    },
  },
};

export default class HomeWebinars {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.container, this.settings);
    this.element.classList.add('ready');
  }

  get container() {
    return this.element.querySelector('.home-webinars-slider');
  }
}
